import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import DynamicQuestion from "./DynamicQuestion";
import UrlAnalyzer from "./UrlAnalyzer";
import { shouldShowQuestion } from "../utils/helpers";

/**
 * QuestionnaireSection component
 * Renders all questions for a section
 */
const QuestionnaireSection = ({
  section,
  responses,
  onSaveResponse,
  isCurrentSection,
  isCompleted,
  websiteUrl,
  onAnalyzeUrl,
  analysisResults,
  isAnalyzing,
  analyzeError,
}) => {
  // Check if this is the first section and should have website analyzer
  const isFirstSection = section.order === 0;

  // If special section for URL analyzer
  const isUrlSection = isFirstSection && section.type === "brandInfo";

  // Determine which questions to show based on conditions
  const filteredQuestions = section.questions
    ? section.questions
        .filter((question) => shouldShowQuestion(question, responses))
        .sort((a, b) => a.order - b.order)
    : [];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="space-y-8"
      >
        {/* URL Analyzer in first section if appropriate */}
        {isUrlSection && (
          <div className="mb-12">
            <UrlAnalyzer
              onAnalyze={onAnalyzeUrl}
              isAnalyzing={isAnalyzing}
              analysisResults={analysisResults}
              analyzeError={analyzeError}
              websiteUrl={websiteUrl}
              inTimelineMode={true}
            />
          </div>
        )}

        {/* Questions */}
        {filteredQuestions.map((question) => (
          <DynamicQuestion
            key={question.id}
            question={question}
            response={responses[question.id]?.value}
            onSaveResponse={(value) => onSaveResponse(question.id, value)}
            isDisabled={!isCurrentSection && !isCompleted}
          />
        ))}

        {/* If no questions, show message */}
        {filteredQuestions.length === 0 && !isUrlSection && (
          <div className="py-4 text-neutral-400 text-center">
            No questions in this section
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default QuestionnaireSection;
